import { useQuery } from '@tanstack/react-query'
import { checkOverdueInvoices } from '../services'
import { CRYPTO_INVOICES_KEYS } from '../../keys'

export const useQueryCheckOverdueInvoices = () => {
	return useQuery({
		queryKey: CRYPTO_INVOICES_KEYS.checkOverdue(),
		queryFn: checkOverdueInvoices,
		// Check every 5 minutes for overdue invoices
		refetchInterval: 5 * 60 * 1000,
		// Keep checking even when window is not focused
		refetchIntervalInBackground: true,
		// Always fetch on mount
		staleTime: 0,
	})
}
